module.exports = __webpack_public_path__ + "static/story2-f0674772d75c5bf5ba4a7da42822dcd3.png";